import { useQuery } from '@apollo/client';
import { UserBookingDetailsDocument } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import { Col, Container, Row } from 'react-bootstrap';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import Guests from '../sections/Guests';

type Props = {
  bookingId: string;
};

export default function BookingGuestsLandingPage({ bookingId }: Props) {
  const { data, loading, error } = useQuery(UserBookingDetailsDocument, {
    variables: { id: bookingId },
    fetchPolicy: 'cache-and-network',
  });

  // Handle loading/errors
  if (loading && !data) {
    return <LoadingPage />;
  }

  if (error && !data) {
    return <ErrorPage error={error} />;
  }

  const { booking } = data;

  // Create isInFuture boolean
  const isInFuture =
    DateTime.now() <
    DateTime.fromISO(booking.group.start.utc, {
      zone: 'utc',
    });

  return (
    <Container className="mt-4">
      <Row>
        <Col xs={12} sm={8} md={7} className="mx-auto mt-3">
          <h4 className="mb-3">Your Team's Trip Forms</h4>
          <div className="mb-3">
            <ol>
              <li>
                Click "<strong>Add Trip Form</strong>" and fill in your trip
                details.
              </li>
              <li>
                If you've booked for other people, click "
                <strong>Copy Link for Friend</strong>" and share it with them.
              </li>
              <li>
                Each link is unique, so make sure to use a different one for
                each team member.
              </li>
            </ol>
          </div>
          <Guests
            group={booking.group}
            isInFuture={isInFuture}
            spaces={booking.spaces}
            userID={booking.user.id}
            hideSocialProof
          />
        </Col>
      </Row>
    </Container>
  );
}
